var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:`${_vm.btnClass} ${_vm.position} no-select tr-btn`,attrs:{"role":"button","aria-label":"Close Button","tabindex":"0"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{class:`icon icon-${_vm.icon}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }